import { render, staticRenderFns } from "./drawerBase.vue?vue&type=template&id=69fa8d87&"
import script from "./drawerBase.vue?vue&type=script&lang=js&"
export * from "./drawerBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports